<div class="progress-loader" [hidden]="!loading">
  <div class="loading-spinner">
    <mat-spinner strokeWidth="3" diameter="150"></mat-spinner>
  </div>
</div>
